import { defineMessage } from 'services/localization';

export const messages = {
    titleAutomaticLogOut: defineMessage('automatic_log_out'),
    titleSecurity: defineMessage('security'),
    optionSession: defineMessage('log_me_out_after_minutes_of_inactivity'),
    verifyDescription: defineMessage('backup_options_can_be_u_o_the_authenticator_app'),
    buttonSetup: defineMessage('setup'),
    buttonChange: defineMessage('change'),
};
